module.exports = __webpack_public_path__ + "img/banner1.fb2dfc89.jpeg";